import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Request interceptor to attach bearer token
axiosInstance.interceptors.request.use(
  (config) => {
    const adminInfo = localStorage.getItem("adminInfo");
    if (adminInfo) {
      try {
        const { token } = JSON.parse(adminInfo);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (e) {
        console.error("Error parsing adminInfo from localStorage", e);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for global error management
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle unauthorized errors (401)
    if (error.response?.status === 401) {
      localStorage.removeItem("adminInfo");
      if (window.location.pathname !== "/login") {
        toast.error("Session expired. Please login again.");
        window.location.href = "/login";
      }
    }

    // You could also add a global toast here for other 500 errors if needed:
    // else if (error.response?.status >= 500) {
    //   toast.error("Server error. Please try again later.");
    // }

    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
